import Cookies from "universal-cookie";

const cookies = new Cookies();

const decodeBase64 = (value) => {
  if (typeof window !== "undefined" && typeof window.atob === "function") {
    return window.atob(value);
  }
  if (typeof Buffer !== "undefined") {
    return Buffer.from(value, "base64").toString("binary");
  }
  throw new Error("Base64 decoder is not available in this environment.");
};

export const decodeJwtToken = (token) => {
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      decodeBase64(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Invalid JWT token:", error);
    return null;
  }
};

export const getAuthToken = () => cookies.get("authToken");

export const getTokenPayload = () => {
  const token = getAuthToken();
  return decodeJwtToken(token);
};

export const getPermissionsFromToken = () => {
  const payload = getTokenPayload();
  return Array.isArray(payload?.permissions) ? payload.permissions : [];
};

export const userHasPermission = (permissions, requiredPermissions = []) => {
  if (!Array.isArray(permissions)) return false;
  if (permissions.includes("*")) return true;
  if (!requiredPermissions || requiredPermissions.length === 0) return true;
  return requiredPermissions.some((permission) =>
    permissions.includes(permission)
  );
};

